import { ApiRequest } from "src/models/api.request";
import VerikontrolDTO from "src/models/Genel/VerikontrolDTO";
import api from "src/services/core/api";

const controllerName = "VerikontrolDTO";

export const veriKontrolApi = api.injectEndpoints({
    endpoints: builder => ({
        getByOrganizasyonId: builder.query<Array<VerikontrolDTO>, number>({
            query: (organizasyonId) => {
                let apiReq:ApiRequest<VerikontrolDTO> = {
                    sorts: [{ fieldName: "id" }],
                    filters: {
                        groupOperator: "and",
                        predicates: [{
                            fieldName: "organizasyonId",
                            operator: "=",
                            value1: organizasyonId,
                        }]
                    }
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: apiReq
                }
            },
            providesTags:["Verikontrol"]
        }),
        updateVerikontrol: builder.mutation<VerikontrolDTO, VerikontrolDTO>({
            query: (request) => ({
              url: controllerName,
              method: "PUT",
              body: request
            }),
            invalidatesTags: ["Verikontrol"]
          }),
    }),
})

export const { useGetByOrganizasyonIdQuery, useUpdateVerikontrolMutation } = veriKontrolApi;